export default __webpack_public_path__ + "static/media/glygen-one-page-brochure-2.1c355501.pdf";